export default __webpack_public_path__ + "static/media/gallery_05.e80b36ff.jpg";